import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=98caad28&"
import script from "./sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./sidebar.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/skoller/Workspaces/lisense/LisenseWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98caad28')) {
      api.createRecord('98caad28', component.options)
    } else {
      api.reload('98caad28', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=98caad28&", function () {
      api.rerender('98caad28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/sidebar/sidebar.vue"
export default component.exports